import React from "react";
import { Grid, TextField, Button, Box } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const AccountDetailEditForm = ({ userDetails, onCancel, onSave }) => {
  const initialValues = {
    account_number: userDetails?.employee_salary?.account_number || "",
    bank_name: userDetails?.employee_salary?.bank_name || "",
    bank_branch: userDetails?.employee_salary?.bank_branch|| "",
    ifsc_code: userDetails?.employee_salary?.ifsc_code || "",
    pan_number: userDetails?.employee_salary?.pan_number || "",
    pf_number: userDetails?.employee_salary?.pf_number || "",
    esi_number: userDetails?.employee_salary?.esi_number || "",
  };

  const validationSchema = Yup.object().shape({
   
    account_number: Yup.string().required("Required"),
    ifsc_code: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    const payload = {
      id: userDetails?.id,
      employee_salary: {
        ...userDetails?.employee_salary,
        ...values,
      },
    };
    onSave(payload);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, touched, errors }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Account Number"
                fullWidth
                name="account_number"
                value={values.account_number}
                onChange={handleChange}
                error={touched.account_number && Boolean(errors.account_number)}
                helperText={touched.account_number && errors.account_number}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Bank Name"
                fullWidth
                name="bank_name"
                value={values.bank_name}
                onChange={handleChange}
                error={touched.bank_name && Boolean(errors.bank_name)}
                helperText={touched.bank_name && errors.bank_name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Branch"
                fullWidth
                name="bank_branch"
                value={values.bank_branch}
                onChange={handleChange}
                error={touched.bank_branch && Boolean(errors.bank_branch)}
                helperText={touched.bank_branch && errors.bank_branch}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="IFSC Code"
                fullWidth
                name="ifsc_code"
                value={values.ifsc_code}
                onChange={handleChange}
                error={touched.ifsc_code && Boolean(errors.ifsc_code)}
                helperText={touched.ifsc_code && errors.ifsc_code}
              />
            </Grid>
             <Grid item xs={12} sm={6}>
              <TextField
                label="PAN Number"
                fullWidth
                name="pan_number"
                value={values.pan_number}
                onChange={handleChange}
                error={touched.pan_number && Boolean(errors.pan_number)}
                helperText={touched.pan_number && errors.pan_number}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="PF Number"
                fullWidth
                name="pf_number"
                value={values.pf_number}
                onChange={handleChange}
                error={touched.pf_number && Boolean(errors.pf_number)}
                helperText={touched.pf_number && errors.pf_number}
              />
            </Grid>
             <Grid item xs={12} sm={6}>
              <TextField
                label="ESI Number"
                fullWidth
                name="esi_number"
                value={values.esi_number}
                onChange={handleChange}
                error={touched.esi_number && Boolean(errors.esi_number)}
                helperText={touched.esi_number && errors.esi_number}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                <Button variant="outlined" color="primary" onClick={onCancel}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" >
                Save
              </Button>
              
              </Box>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default AccountDetailEditForm;
